import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-globalize',
	templateUrl:'./GlobalizePluginPage.html',
	styles: [],
	styleUrls:['./GlobalizePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GlobalizePluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_591 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>globalize</artifactId>
</dependency>
\`\`\``;
	mdContent_592 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:globalize:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_593 = `\`\`\`json
"globalize": "*"
\`\`\``;
	mdContent_594 = `\`\`\`java
GlobalizeCultures culture = GlobalizeCultures.en_US;
String tag = culture.toString(); // "en-US"
\`\`\``;
	mdContent_595 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.globalize.cultures;
}
\`\`\``;
	mdContent_596 = `\`\`\`java
// Automatically loaded as a jQuery UI dependency.
// To reference a culture programmatically:
GlobalizeCultures culture = GlobalizeCultures.en_US;
String tag = culture.toString(); // "en-US"
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
